import { isServerRendering } from "~/lib/ssr/runtime";
import { createFileRoute } from "@tanstack/react-router";
import { StocksPagePending } from "~/features/stocks/routing/stocks-page-pending";
import { warmSymbolShellFromListRoute } from "~/features/symbol/routing/warm-symbol-shell";
import { createPublicBrowseHead } from "~/lib/ssr/public-browse-head";
import { STOCKS_SOCIAL_METADATA } from "~/lib/social-metadata";

export const Route = createFileRoute("/_app/stocks")({
  ssr: true,
  // Paint the page silhouette inside the live chrome the moment navigation
  // commits (no 1s default delay) while the lazy chunk loads.
  pendingComponent: StocksPagePending,
  pendingMs: 0,
  loader: ({ context, preload }) => {
    const warm = import("~/features/stocks/stocks-route").then((module) =>
      module.preloadStocksRoute(context),
    );
    if (isServerRendering() || preload) return warm;
    void warm;
    warmSymbolShellFromListRoute(preload);
  },
  head: () => createPublicBrowseHead("/stocks", STOCKS_SOCIAL_METADATA),
});
